import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalVariable } from "app/global/global";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { UsuarioPanelService } from "app/services/usuario-panel.service";
import { UsuarioPanel } from "app/models/usuarioPanel.interface";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationComponent } from "app/shared/notification/notification.component";
import { SpinnerService } from "app/services/spinner.service";
import { throwError } from "rxjs";
import { switchMap, tap, catchError } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { TerminosYCondicionesDialogComponent } from "../../shared/terminos-ycondiciones-dialog/terminos-ycondiciones-dialog.component";
import { TerminosYCondicionesService } from "../../services/terminos.service";
import { camposFaltantes } from "../../utils/form-errors.utils";

@Component({
  selector: "app-login-panel",
  templateUrl: "./login-panel.component.html",
  styleUrls: ["./login-panel.component.scss"],
})
export class LoginPanelComponent implements OnInit {
  //
  VERSION: string = GlobalVariable.VERSION_FRONT;
  loginForm: FormGroup;
  usuarioPanel: UsuarioPanel;
  response: any;
  hidePassword = true;

  //
  constructor(
    private router: Router,
    private usuarioPanelService: UsuarioPanelService,
    private snackBar: MatSnackBar,
    private spinnerService: SpinnerService,
    private dialog: MatDialog,
    private terminosService: TerminosYCondicionesService
  ) {}

  //
  ngOnInit(): void {
    this.loginForm = new FormGroup({
      nombreUsuario: new FormControl("", Validators.required),
      password: new FormControl("", Validators.required),
    });
  }

  //
  openSnackBar(message: string, action: string) {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: {
        message: message,
        action: action,
      },
      duration: 2500,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: [action],
    });
  }

  login(event) {
    if (this.loginForm.invalid) {
      this.openSnackBar(camposFaltantes(this.loginForm, { nombreUsuario: "Usuario", password: "Password" }), "error");
      return;
    }
    this.spinnerService.mostrarSpinner();

    this.usuarioPanelService
      .login(event)
      .pipe(
        catchError((error) => {
          this.spinnerService.ocultarSpinner();
          this.openSnackBar(
            "Ingreso fallido: " + (error?.error?.error || ""),
            "error"
          );
          return throwError(() => error);
        })
      )
      .subscribe({
        next: (response: any) => {
          if (!response.tc_valido) {
            this.spinnerService.ocultarSpinner();
            this.manejarTerminosYCondiciones(response);
          } else {
            this.completarLogin(response);
          }
        },
        error: () => {
          this.usuarioPanelService.deleteDatosAutorizacion();
        },
      });
  }

  private manejarTerminosYCondiciones(response: any) {
    const dialogRef = this.dialog.open(TerminosYCondicionesDialogComponent, {
      width: "600px",
      disableClose: true,
      data: {
        tc: response.tc,
        primeraVez: response.tc_primera_vez,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.aceptado) {
        this.aceptarTerminosYCompletar(response);
      } else {
        this.openSnackBar(
          "Debe aceptar los términos y condiciones para continuar",
          "error"
        );
      }
    });
  }

  private aceptarTerminosYCompletar(response: any) {
    this.spinnerService.mostrarSpinner();

    this.terminosService
      .aceptarTerminos({
        tipo_usuario: response.tc.tipo_usuario,
        id: response.userId,
        tc_aceptado: response.tc.version,
      })
      .pipe(
        tap(() => {
          const dataToken = { token: response.token };
          this.usuarioPanelService.handleData(dataToken);
        }),
        switchMap(() => this.usuarioPanelService.datosAutorizacion()),
        catchError((error) => {
          this.spinnerService.ocultarSpinner();
          this.openSnackBar(
            "Error al aceptar los términos y condiciones",
            "error"
          );
          return throwError(() => error);
        })
      )
      .subscribe({
        next: (data) => this.finalizarLogin(data),
        error: () => this.usuarioPanelService.deleteDatosAutorizacion(),
      });
  }

  private completarLogin(response: any) {
    const dataToken = { token: response.token };
    this.usuarioPanelService.handleData(dataToken);

    this.usuarioPanelService
      .datosAutorizacion()
      .pipe(
        catchError((error) => {
          this.spinnerService.ocultarSpinner();
          this.usuarioPanelService.deleteDatosAutorizacion();
          this.openSnackBar("Error al obtener datos de autorización", "error");
          return throwError(() => error);
        })
      )
      .subscribe((data) => this.finalizarLogin(data));
  }

  private finalizarLogin(data: any) {
    this.usuarioPanelService.setDatosAutorizacion(data);
    this.spinnerService.ocultarSpinner();
    this.router.navigate(["/seccion-panel/home-panel/"]);
  }
}
